import type { GamePageContext } from "@/features/game/data";
import { createPlayApi } from "./play-api";
import { createPlayShellReader } from "./play-shell";
import { readPlayActivity } from "./play-activity";
import { readPlayEpisodes } from "./play-episodes";
import { readPlayRequests } from "./play-requests";
export function createPlayReader({
  signal,
  context,
}: {
  signal?: AbortSignal | undefined;
  context?: GamePageContext | null;
}) {
  const api = createPlayApi({ signal });
  const { publicShell, featuredPublicShell, canEnter, loadShell } =
    createPlayShellReader({ signal, context, api });
  return {
    api,
    publicShell,
    featuredPublicShell,
    canEnter,
    shell: (slug: string) =>
      loadShell({
        slug,
        includeParticipation: false,
      }),
    activity: async (slug: string) => {
      const shell = await loadShell({
        slug,
        includeParticipation: true,
      });
      return shell ? readPlayActivity({ api, shell }) : null;
    },
    episodes: async (slug: string) => {
      const shell = await loadShell({
        slug,
        includeParticipation: true,
      });
      return shell ? readPlayEpisodes({ api, shell }) : null;
    },
    requests: async (slug: string) => {
      const shell = await loadShell({
        slug,
        includeParticipation: true,
      });
      return shell ? readPlayRequests({ api, shell }) : null;
    },
  };
}
